const initCarouselInstagram = () => {
  const carousel = document.querySelectorAll("[data-carousel]");
  const roxysCinema = document.querySelectorAll('[data-roxy]')

  if (carousel.length) {
      let isDragStart = false,
          isDragging = false,
          prevPageX,
          prevScrollLeft,
          positionDiff;

      const dragStop = () => {
				const elementocarousel = event.currentTarget
				isDragStart = false;
				elementocarousel.classList.remove("dranging");

				if (!isDragging) return;
				isDragging = false;
      };

      const dragStart = (event) => {
				const elementocarousel = event.currentTarget
				isDragStart = true;
				prevPageX = event.pageX || event.touches[0].pageX;
				prevScrollLeft = elementocarousel.scrollLeft;
      };

      const dranging = (event) => {
				const elementocarousel = event.currentTarget
				if (!isDragStart) return;
				event.preventDefault();
				isDragging = true;
				elementocarousel.classList.add("dranging");
				positionDiff = (event.pageX || event.touches[0].pageX) - prevPageX;
				elementocarousel.scrollLeft = prevScrollLeft - positionDiff;
      };
    
      carousel.forEach(item => {
        item.addEventListener("mousedown", dragStart);
        item.addEventListener("touchstart", dragStart);
  
        item.addEventListener("mousemove", dranging);
        item.addEventListener("touchmove", dranging);
  
        item.addEventListener("mouseup", dragStop);
        item.addEventListener("mouseleave", dragStop);
        item.addEventListener("touchend", dragStop);
      })
      

			//--------- Mostrar escondder --------- //

			carousel[2].classList.add('ativo')

			const mostrarFilmesReferenteCinema = (cinema, index) => {
				const totalGrid = carousel[index].children.length
				carousel.forEach(item => item.classList.remove('ativo'))
				carousel[index].classList.add('ativo')

				if(totalGrid > 2) {
					carousel[index].setAttribute("style", `grid-template-columns: repeat(${totalGrid}, 10.5rem);`)
				} else {
					carousel[index].setAttribute("style", `grid-template-columns: repeat(2, 1fr`)
				}
			}

			roxysCinema.forEach((item, index) => {
				item.addEventListener('click', () => {
					mostrarFilmesReferenteCinema(item, index)
				})
			})
  }
};

export default initCarouselInstagram